import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { AlbertaIconModule } from 'src/app/shared/components/alberta-icon/alberta-icon.module';
import { AlbertaCommonComponentsModule } from 'src/app/shared/components/common/common-components.module';
import { InfoBoxComponent } from 'src/app/shared/components/common/info-box/info-box.component';
import { WarningItemComponent } from 'src/app/shared/components/common/warning-item/warning-item.component';
import { InputTemplatesModule } from 'src/app/shared/components/inputs/_templates/input-templates.module';
import { AlbertaInputsModule } from 'src/app/shared/components/inputs/inputs-components.module';
import { WizardPageModule } from 'src/app/shared/components/wizard-page/wizard-page.module';

import { KimRecipientFilterComponent } from '../kim-recipient-search/kim-recipient-filter/kim-recipient-filter.component';
import { KimRecipientSearchModal } from '../kim-recipient-search/kim-recipient-search.modal';
import { KimSendModal } from './kim-send.modal';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule.forChild(),
    AlbertaInputsModule,
    InputTemplatesModule,
    WizardPageModule,
    AlbertaCommonComponentsModule,
    AlbertaIconModule,
    InfoBoxComponent,
    WarningItemComponent,
  ],
  declarations: [KimSendModal, KimRecipientSearchModal, KimRecipientFilterComponent],
})
export class KimSendModule {}
